import BaseModelInstance from './base.model'
import { UniversitySession as ModelDefinition } from './model-definitions'

class UniversitySession extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default UniversitySession
